// Hộp "Giải CAPTCHA" (giai đoạn 2 "màn hình chính bot", 05/10/2026): CHỦ bot nhìn màn hình trình duyệt của bot ngay trong Boss và dùng chuột/bàn phím
// của chính mình để giải xác minh (thanh trượt "Drag the slider to fit the puzzle"…). Đây là điều khiển từ xa BỞI NGƯỜI — không có gì tự động giải
// CAPTCHA. Phiên chỉ mở khi người dùng bấm nút; đóng hộp / F5 / mất mạng → máy chủ tự đóng phiên và bot gỡ trình gỡ lỗi.
//
// Giao thức (WS /ui): gửi {type:"dieuKhien", botId, on} mở/đóng; {type:"dkSuKien", botId, ev} sự kiện với toạ độ CHUẨN HOÁ 0..1 theo ảnh hiển thị
// (src/shared/dieu-khien-tu-xa.ts); nhận {type:"dk.state", botId, state, text?, w?, h?} và {type:"dk.frame", botId, at, jpegB64, w, h}.
import { api, ApiError, errMsg } from "./api";
import { h, toast } from "./dom";
import { store } from "./store";
import type { Bot } from "./types";
import { uiSocket } from "./ws";
import { DK_MAX_GO } from "../../../src/shared/dieu-khien-tu-xa";
import { PHIEN_BAN_DIEU_KHIEN_TU_XA, laPhienBan, soSanhPhienBan } from "../../../src/shared/phien-ban-plugin";

export const DK_CANH_BAO = "Bạn đang điều khiển trình duyệt của bot. Chỉ dùng để giải xác minh; không đăng nhập hộ nick lạ.";
const DK_HAN_MO_MS = 8_000; // gửi yêu cầu mở mà máy chủ im lặng quá chừng này → báo (Boss cũ chưa có tính năng / mạng chậm)
const DK_RE_MIN_MS = 20; // rê chuột gửi tối đa ~50 lần/giây (máy chủ cho 60)
const FPS_WINDOW_MS = 3000;
// Phím KHÔNG in được (gửi dạng phím); chữ in được đi đường gõ chữ (insertText) để bộ gõ tiếng Việt/emoji/dán hoạt động đúng.
const PHIM_DAC_BIET = new Set(["Enter", "Backspace", "Tab", "Escape", "Delete", "Home", "End", "PageUp", "PageDown", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Insert", "F1", "F2", "F3", "F4", "F6", "F7", "F8", "F9", "F10", "F11", "F12"]);

type TrangThai = "cho" | "dang" | "dong" | "loi";
interface HopDangMo { botId: string; dong: () => void; focus: () => void }
let hienTai: HopDangMo | null = null;

/** Mở hộp Giải CAPTCHA cho bot. Đã mở hộp của chính bot này → chỉ đưa con trỏ về hộp (không mở thêm / không gửi yêu cầu thứ hai). */
export function moDieuKhienTuXa(bot: Bot): void {
  if (hienTai) {
    if (hienTai.botId === bot.id) { hienTai.focus(); return; }
    hienTai.dong(); // chỉ một phiên điều khiển mỗi lúc trên một trình duyệt web
  }
  const botId = bot.id;
  let tt: TrangThai = "cho";
  let song = true;
  let dongBoMo: number | undefined;
  let khungCuoi = "";
  let raf = 0;
  const stamps: number[] = [];
  let guiLuc = 0; // lúc gửi thao tác gần nhất chưa thấy khung hình đáp lại → đo độ trễ thao tác→hình
  let tre = 0;
  let dangNhan = false;
  let reCho: { x: number; y: number } | null = null;
  let reTimer: number | undefined;
  let reLanCuoi = 0;

  const man = h("div", { class: "dk-man", "data-testid": "dk-man", tabindex: "-1" });
  const hinh = h("img", { class: "dk-hinh", alt: `Màn hình trình duyệt của ${bot.name}`, draggable: false, "data-testid": "dk-hinh", hidden: true });
  const cho = h("div", { class: "dk-cho", "data-testid": "dk-cho" }, "Đang xin phiên điều khiển…");
  // Ô nhập ẩn: nhận bàn phím + bộ gõ (Telex/VNI), dán, emoji; chữ in được gửi bằng insertText.
  const nhap = h("textarea", { class: "dk-nhap", "aria-label": "Gõ vào trình duyệt của bot", autocomplete: "off", autocapitalize: "off", spellcheck: false, "data-testid": "dk-nhap", tabindex: "0" });
  man.append(hinh, cho, nhap);

  const trangThai = h("span", { class: "tag", "data-testid": "dk-trang-thai", role: "status" }, "Đang kết nối…");
  const fps = h("span", { class: "tag", title: "Số khung hình nhận được mỗi giây", "data-testid": "dk-fps" }, "— khung/giây");
  const treTag = h("span", { class: "tag", title: "Từ lúc bạn bấm/nhả/gõ tới khi thấy hình đổi — gồm đường truyền + máy bot", "data-testid": "dk-tre" }, "trễ —");
  const loi = h("p", { class: "err small wrap", hidden: true, "data-testid": "dk-loi", role: "alert" });
  const moLai = h("button", { type: "button", class: "mini", hidden: true, "data-testid": "dk-mo-lai", title: "Xin phiên điều khiển lại", onclick: () => guiMo() }, "Mở lại");
  const xong = h("button", { type: "button", class: "ok", "data-testid": "dk-xong", title: "Đóng phiên điều khiển và cho bot chạy lại (bỏ trạng thái tạm dừng vì xác minh, nếu có)", onclick: () => void xongViec() }, "Xong — cho bot chạy lại");
  // (09/10/2026) "Xong" bị chặn vì bot VẪN thấy CAPTCHA / hộp cần người (kiểm trước khi mở lại) → người dùng chắc chắn đã xử lý vẫn ép được, như nút "Vẫn cho chạy lại" ở trang Chờ duyệt
  const ep = h("button", { type: "button", class: "danger", hidden: true, "data-testid": "dk-ep", title: "Bot báo vẫn còn thấy CAPTCHA / hộp cần xử lý. Chỉ bấm khi bạn chắc đã xử lý xong (hoặc đó là hộp không quan trọng): Boss bỏ trạng thái tạm dừng ngay, không hỏi bot nữa.", onclick: () => void epChayLai() }, "Vẫn cho chạy lại — tôi chắc đã xử lý");
  const dongBtn = h("button", { type: "button", "data-testid": "dk-dong", title: "Đóng hộp này — phiên điều khiển đóng, bot vẫn giữ nguyên trạng thái", onclick: () => dong() }, "Đóng");
  const nutX = h("button", { type: "button", class: "kb-noi-x", "aria-label": "Đóng hộp", title: "Đóng hộp (đóng phiên điều khiển)", "data-testid": "dk-dong-x", onclick: () => dong() }, "×");
  const hop = h("div", { class: "modal dk-hop", role: "document", "data-testid": "dk-hop" },
    h("div", { class: "row between dk-dau" }, h("h3", { "data-testid": "dk-tieu-de" }, `Giải CAPTCHA — ${bot.name}`), nutX),
    h("p", { class: "warn-box dk-canh-bao wrap", "data-testid": "dk-canh-bao" }, DK_CANH_BAO),
    h("div", { class: "row dk-thanh" }, trangThai, fps, treTag, moLai),
    loi,
    man,
    h("p", { class: "small muted dk-huong-dan wrap", "data-testid": "dk-huong-dan" }, "Kéo thanh trượt bằng chuột. Muốn gõ chữ: bấm vào hình trước. Phiên tự đóng sau 3 phút không thao tác."),
    h("div", { class: "row end dk-chan" }, ep, xong, dongBtn));
  const nen = h("div", { class: "modal-wrap dk-nen", role: "dialog", "aria-modal": "true", "aria-label": `Giải CAPTCHA — ${bot.name}`, "data-testid": "dk-nen" }, hop);

  // ---------------- gửi lên máy chủ ----------------
  function gui(ev: Record<string, unknown>): void {
    if (tt !== "dang") return;
    uiSocket.send({ type: "dkSuKien", botId, ev });
    if (ev.k !== "chuot" || ev.a !== "di") guiLuc = Date.now();
  }
  function guiMo(): void {
    tt = "cho";
    ve();
    uiSocket.send({ type: "dieuKhien", botId, on: true });
    window.clearTimeout(dongBoMo);
    dongBoMo = window.setTimeout(() => { if (tt === "cho" && song) { tt = "loi"; ve(`Máy chủ Boss không phản hồi sau ${DK_HAN_MO_MS / 1000} giây — kiểm tra mạng rồi bấm Mở lại (hoặc Boss chưa hỗ trợ điều khiển từ xa).`); } }, DK_HAN_MO_MS);
  }

  // ---------------- vẽ trạng thái ----------------
  function ve(chiTiet?: string): void {
    const t = tt === "cho" ? "Đang xin phiên…" : tt === "dang" ? "Đang điều khiển" : tt === "dong" ? "Đã đóng" : "Không điều khiển được";
    trangThai.textContent = t;
    trangThai.className = `tag${tt === "dang" ? " ok" : tt === "loi" ? " err" : tt === "cho" ? " warn" : ""}`;
    loi.hidden = !chiTiet;
    loi.textContent = chiTiet ?? "";
    if (tt === "cho" || tt === "dang") ep.hidden = true; // mở lại phiên → bỏ nút ép cũ
    moLai.hidden = !(tt === "dong" || tt === "loi") || !song || /cập nhật plugin|Chỉ chủ bot/.test(chiTiet ?? "");
    cho.hidden = tt === "dang" && !hinh.hidden;
    cho.textContent = tt === "cho" ? "Đang xin phiên điều khiển…" : tt === "dang" ? "Đang chờ hình từ bot…" : tt === "loi" ? "Chưa mở được phiên điều khiển" : "Phiên điều khiển đã đóng";
    man.classList.toggle("dk-tat", tt !== "dang");
    if (tt !== "dang") { fps.textContent = "— khung/giây"; treTag.textContent = "trễ —"; stamps.length = 0; }
  }
  function veFps(now: number): void {
    while (stamps.length && now - stamps[0]! > FPS_WINDOW_MS) stamps.shift();
    const n = stamps.length >= 2 ? (stamps.length - 1) / (Math.max(1000, now - stamps[0]!) / 1000) : stamps.length;
    fps.textContent = `${n < 10 ? n.toFixed(1) : Math.round(n)} khung/giây`;
  }

  // ---------------- nhận từ máy chủ ----------------
  function khiCoKhung(jpegB64: string): void {
    if (tt !== "dang") return;
    khungCuoi = jpegB64;
    const now = Date.now();
    stamps.push(now);
    if (guiLuc) { const d = now - guiLuc; guiLuc = 0; tre = tre ? Math.round(tre * 0.6 + d * 0.4) : d; treTag.textContent = `trễ ~${tre} ms`; }
    veFps(now);
    if (!raf) raf = requestAnimationFrame(() => { // vẽ khung mới nhất mỗi lượt vẽ; khung tới dồn không xếp hàng giải mã
      raf = 0;
      hinh.src = `data:image/jpeg;base64,${khungCuoi}`;
      if (hinh.hidden) { hinh.hidden = false; ve(); }
    });
  }
  const offMsg = uiSocket.on((ev) => {
    if (!song) return;
    if (ev.type === "dk.frame" && ev.botId === botId) { khiCoKhung(ev.jpegB64); return; }
    if (ev.type === "dk.state" && ev.botId === botId) {
      window.clearTimeout(dongBoMo);
      if (ev.state === "mo") { tt = "cho"; ve(); }
      else if (ev.state === "dang_dieu_khien") { const truoc = tt; tt = "dang"; ve(); if (truoc !== "dang") nhap.focus({ preventScroll: true }); }
      else if (ev.state === "sap_het_han") { toast(ev.text ?? "Phiên sắp tự đóng vì không thao tác", "warn"); trangThai.textContent = "Sắp tự đóng"; }
      else if (ev.state === "da_dong") { tt = "dong"; hinh.hidden = true; ve(ev.text); }
      else if (ev.state === "tu_choi") { tt = "loi"; hinh.hidden = true; ve(ev.text); }
    } else if (ev.type === "bot.changed" && ev.bot.id === botId && !ev.bot.online && tt === "dang") {
      // máy chủ cũng báo da_dong; đây là dự phòng nếu tin đó tới sau
      tt = "dong"; hinh.hidden = true; ve("Bot đã ngoại tuyến — phiên điều khiển đã đóng");
    }
  });
  const offState = uiSocket.onState((on) => {
    if (!song) return;
    if (!on && (tt === "dang" || tt === "cho")) { tt = "dong"; hinh.hidden = true; ve("Mất kết nối realtime với Boss — phiên điều khiển đã đóng (máy chủ tự đóng). Bấm Mở lại khi có mạng."); }
  });

  // ---------------- chuột ----------------
  // Toạ độ chuẩn hoá theo vùng ẢNH THẬT (trừ viền đen nếu ảnh nhỏ hơn khung) → không phụ thuộc kích thước hiển thị.
  function chuanHoa(e: { clientX: number; clientY: number }): { x: number; y: number } | null {
    const r = hinh.getBoundingClientRect();
    const nw = hinh.naturalWidth, nh = hinh.naturalHeight;
    if (!r.width || !r.height || !nw || !nh) return null;
    const k = Math.min(r.width / nw, r.height / nh);
    const cw = nw * k, ch = nh * k;
    const trai = r.left + (r.width - cw) / 2, tren = r.top + (r.height - ch) / 2;
    const c = (v: number): number => Math.min(1, Math.max(0, v));
    return { x: c((e.clientX - trai) / cw), y: c((e.clientY - tren) / ch) };
  }
  function xaRe(): void {
    reTimer = undefined;
    if (!reCho) return;
    const p = reCho;
    reCho = null;
    reLanCuoi = Date.now();
    gui({ k: "chuot", a: "di", x: p.x, y: p.y });
  }
  function re(p: { x: number; y: number }): void {
    reCho = p;
    if (reTimer !== undefined) return;
    reTimer = window.setTimeout(xaRe, Math.max(0, DK_RE_MIN_MS - (Date.now() - reLanCuoi)));
  }
  function xaReNgay(): void { if (reTimer !== undefined) { window.clearTimeout(reTimer); } xaRe(); }
  hinh.addEventListener("pointerdown", (e) => {
    if (tt !== "dang") return;
    const p = chuanHoa(e);
    if (!p) return;
    e.preventDefault();
    nhap.focus({ preventScroll: true });
    try { hinh.setPointerCapture(e.pointerId); } catch { /* không phải con trỏ chủ động */ }
    xaReNgay();
    dangNhan = true;
    gui({ k: "chuot", a: "xuong", x: p.x, y: p.y, nut: e.button === 1 ? 1 : e.button === 2 ? 2 : 0, n: Math.min(3, Math.max(1, e.detail || 1)) });
  });
  hinh.addEventListener("pointermove", (e) => {
    if (tt !== "dang") return;
    const p = chuanHoa(e);
    if (p) re(p);
  });
  const nha = (e: PointerEvent): void => {
    if (tt !== "dang" || !dangNhan) return;
    dangNhan = false;
    const p = chuanHoa(e);
    xaReNgay();
    if (p) gui({ k: "chuot", a: "len", x: p.x, y: p.y, nut: e.button === 1 ? 1 : e.button === 2 ? 2 : 0 });
  };
  hinh.addEventListener("pointerup", nha);
  hinh.addEventListener("pointercancel", nha);
  hinh.addEventListener("contextmenu", (e) => e.preventDefault()); // chuột phải thuộc về bot, không mở menu của Boss
  hinh.addEventListener("dragstart", (e) => e.preventDefault());
  hinh.addEventListener("wheel", (e) => {
    if (tt !== "dang") return;
    const p = chuanHoa(e);
    if (!p) return;
    e.preventDefault();
    const k = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? 400 : 1;
    gui({ k: "cuon", x: p.x, y: p.y, dx: Math.max(-2000, Math.min(2000, e.deltaX * k)), dy: Math.max(-2000, Math.min(2000, e.deltaY * k)) });
  }, { passive: false });

  // ---------------- bàn phím ----------------
  function phim(a: "xuong" | "len", e: KeyboardEvent): void {
    if (tt !== "dang" || e.isComposing) return;
    const chuCaiVoiPhimTat = (e.ctrlKey || e.metaKey) && e.key.length === 1;
    if (!PHIM_DAC_BIET.has(e.key) && !chuCaiVoiPhimTat) return; // chữ in được: để ô nhập nhận rồi gửi insertText
    e.preventDefault();
    const ev: Record<string, unknown> = { k: "phim", a, key: e.key };
    if (/^[A-Za-z0-9]{1,32}$/.test(e.code)) ev.code = e.code;
    if (e.ctrlKey) ev.ctrl = true;
    if (e.altKey) ev.alt = true;
    if (e.shiftKey) ev.shift = true;
    if (e.metaKey) ev.meta = true;
    gui(ev);
  }
  nhap.addEventListener("keydown", (e) => phim("xuong", e));
  nhap.addEventListener("keyup", (e) => phim("len", e));
  function xaChu(): void {
    const v = nhap.value;
    nhap.value = "";
    if (!v || tt !== "dang") return;
    // Cắt theo ký tự (không cắt đôi emoji/cặp thay thế), mỗi mảnh ≤ DK_MAX_GO đơn vị UTF-16.
    let cuoi = "";
    for (const ch of v) {
      if (cuoi.length + ch.length > DK_MAX_GO) { gui({ k: "go", s: cuoi }); cuoi = ""; }
      cuoi += ch;
    }
    if (cuoi) gui({ k: "go", s: cuoi });
  }
  nhap.addEventListener("input", (e) => { if (!(e as InputEvent).isComposing) xaChu(); });
  nhap.addEventListener("compositionend", () => xaChu());

  // ---------------- đóng ----------------
  function don(): void {
    if (!song) return;
    song = false;
    window.clearTimeout(dongBoMo);
    if (reTimer !== undefined) window.clearTimeout(reTimer);
    if (raf) cancelAnimationFrame(raf);
    offMsg();
    offState();
    nen.remove();
    if (hienTai && hienTai.botId === botId) hienTai = null;
  }
  function dong(): void {
    if (!song) return;
    if (dangNhan) { dangNhan = false; /* nhả chuột nếu đang giữ — phía bot cũng tự nhả khi đóng phiên */ }
    uiSocket.send({ type: "dieuKhien", botId, on: false });
    don();
  }
  // Esc KHÔNG đóng hộp: phím Escape thuộc về trang CAPTCHA của bot. Ô nhập đã preventDefault() cho Escape nên handler Esc toàn cục (app.ts) bỏ qua.
  nen.addEventListener("dong-hop", () => dong()); // đổi trang / phiên đăng nhập hết hạn → đóng phiên

  let biChan: { id: string; nenTang: string }[] = [];
  async function xongViec(): Promise<void> {
    xong.disabled = true; // bấm hai lần = một lần
    ep.hidden = true;
    uiSocket.send({ type: "dieuKhien", botId, on: false });
    try {
      const r = await api<{ items: { id: string; botId: string; nenTang: string }[] }>("GET", "/api/tu-sua/tam-dung");
      const cua = r.items.filter((t) => t.botId === botId);
      const daMo: string[] = [];
      const chan: { id: string; nenTang: string }[] = [];
      let lyDoChan = "";
      for (const t of cua) {
        try { await api("POST", `/api/tu-sua/tam-dung/${encodeURIComponent(t.id)}/bo`, {}); daMo.push(t.nenTang); }
        catch (e) {
          // 409 conXacMinh: bot vẫn thấy CAPTCHA / hộp cần người → hỏi lại (mặc định KHÔNG mở) nhưng cho người dùng ép; lỗi khác → báo như cũ
          if (e instanceof ApiError && (e.details as { conXacMinh?: boolean } | undefined)?.conXacMinh === true) { chan.push(t); lyDoChan = e.message; } else throw e;
        }
      }
      if (chan.length) {
        biChan = chan;
        if (daMo.length) toast(`Đã cho ${bot.name} chạy lại trên ${daMo.join(", ")}`);
        tt = "dong";
        hinh.hidden = true;
        ve(`Đã đóng phiên điều khiển nhưng chưa cho bot chạy lại được: ${lyDoChan}`);
        ep.hidden = false;
        xong.disabled = false;
        return;
      }
      toast(cua.length ? `Đã cho ${bot.name} chạy lại trên ${cua.map((t) => t.nenTang).join(", ")}` : `Đã đóng phiên điều khiển ${bot.name} (bot không bị tạm dừng nên không cần cho chạy lại)`);
      don();
    } catch (e) {
      tt = "dong";
      hinh.hidden = true;
      ve(`Đã đóng phiên điều khiển nhưng chưa cho bot chạy lại được: ${errMsg(e)}`);
      xong.disabled = false;
    }
  }
  async function epChayLai(): Promise<void> {
    if (ep.disabled) return;
    ep.disabled = true; // bấm đúp = một lần
    try {
      for (const t of biChan) await api("POST", `/api/tu-sua/tam-dung/${encodeURIComponent(t.id)}/bo`, { vanChayLai: true });
      toast(`Đã cho ${bot.name} chạy lại trên ${biChan.map((t) => t.nenTang).join(", ")} (bạn chọn mở dù bot còn thấy CAPTCHA / hộp cần bạn xử lý)`);
      don();
    } catch (e) {
      ve(`Chưa cho bot chạy lại được: ${errMsg(e)}`);
      ep.disabled = false;
    }
  }

  // ---------------- mở ----------------
  hienTai = { botId, dong, focus: () => nhap.focus({ preventScroll: true }) };
  document.body.appendChild(nen);
  const ban = bot.extVersion;
  if (!store.user || store.user.id !== bot.ownerId) { tt = "loi"; ve("Chỉ chủ bot mới được điều khiển từ xa bot này"); return; }
  if (!bot.online) { tt = "loi"; ve("Bot đang ngoại tuyến — không điều khiển được"); return; }
  if (laPhienBan(ban) && soSanhPhienBan(ban, PHIEN_BAN_DIEU_KHIEN_TU_XA) < 0) { tt = "loi"; ve(`Bot cần cập nhật plugin lên ${PHIEN_BAN_DIEU_KHIEN_TU_XA} (đang ${ban}) mới điều khiển từ xa được`); return; }
  guiMo();
}
